var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 22.701c5.91 0 10.701-4.791 10.701-10.701S17.911 1.299 12 1.299c-5.91 0-10.701 4.79-10.701 10.7 0 5.911 4.79 10.702 10.701 10.702Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#345D9D",
    d: "M12 0a12 12 0 1 0 12 12A11.966 11.966 0 0 0 12.07 0H12Zm.203 12.407-1.249 4.213h6.683a.336.336 0 0 1 .348.325v.11l-.58 2.006a.434.434 0 0 1-.437.32H6.741l1.714-5.841-1.917.581.435-1.337 1.918-.58 2.412-8.194a.438.438 0 0 1 .435-.32h2.587a.337.337 0 0 1 .348.326v.11L12.64 11.04l1.918-.581-.407 1.395-1.947.552Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLtc);
export default __webpack_public_path__ + "static/media/ltc.40dc3d8e130454287c4843ecf9155d39.svg";
export { ForwardRef as ReactComponent };